var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"qly-container"},[_c('layout-header',{model:{value:(_vm.isCollapse),callback:function ($$v) {_vm.isCollapse=$$v},expression:"isCollapse"}}),_c('section',{staticClass:"qly-center"},[_c('layout-aside',{attrs:{"isCollapse":_vm.isCollapse}}),_c('layout-main',{attrs:{"isCollapse":_vm.isCollapse}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }